import * as React from 'react';
import {withStyles,
  WithStyles,
  StyleRules,
  ClassNameMap
} from '@mui/styles';
import { Theme } from '@mui/styles';
import AppView from '~common/components/app-view/index';
import FormBasedEditor from '~common/form/form-based-editor';

import DefinitionDataProvider from "~common/form/icg-definition-data-provider";
import FormBasedContainer from "~common/form/form-based-container-fc";
import {ContainerTypeEditor} from "~common/form/form-based-container-fc";


const styles = (theme: Theme): StyleRules => ({
  container: {
    width: '100%'
  }
});

interface Props extends React.HTMLProps<HTMLDivElement> {
  history: any;
}

type State = {
  status: "loading" | "ready" | "error";
};

class Invite extends React.Component<
  Props & WithStyles<keyof typeof styles>,
  State
  > {
  constructor(props: Props & WithStyles<keyof typeof styles>) {
    super(props, {});
    this.state = {
      status: "loading"
    };
  }

 componentDidMount() {
  }
  UNSAFE_componentWillReceiveProps(
    newProps: Props & WithStyles<keyof typeof styles>
  ) { }

  render() {

    const {match} = this.props;
    const { classes, history }: { classes: ClassNameMap, history:any } = this.props;

    var data = {}
    return (
      <div className={classes.container}>
        
        <AppView history={history}>
            <DefinitionDataProvider>
              <FormBasedContainer
                containerType={ContainerTypeEditor}
                history={history}
                match={match}
                dataUrl="/api/portal-users/register-unsolicited"
                formSelector={{
                  formType: 'unsolicitedRegisterPortalUser',
                  modules: 'users',
                  userType: 'Any'
                }}
                postOnly={true}
                successMessage="Your account has been created.  You will now be forwarded to the login page."
                // If provided, redirectUrl where the user will be sent upon success
                returnURL="/login"
                submitButtonText="Register"
                // onBeforeSubmitAsyncVerify={this.reCaptcha}
              >
              </FormBasedContainer>
            </DefinitionDataProvider>
        </AppView>
      </div>
    );
  }
}

export default withStyles(styles)(Invite);
